import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './GeneralCardCompleteRound.css';
import React from 'react';
import { canUseDOM, get, getPageThemeColors } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { DefaultCards } from './components/DefaultCards';
import { DropCards } from './components/DropCards';
import { isNil } from '../../utils/IsNil';
export var EGeneralCardCompleteRoundTypes = /*#__PURE__*/function (EGeneralCardCompleteRoundTypes) {
  EGeneralCardCompleteRoundTypes["Default"] = "Default";
  EGeneralCardCompleteRoundTypes["Drop"] = "Drop";
  return EGeneralCardCompleteRoundTypes;
}({});
export var GeneralCardCompleteRound = function GeneralCardCompleteRound(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields) {
    console.info('GeneralCardCompleteRound component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [GeneralCardCompleteRound component is empty: please provide data source]");
    }
    return null;
  }
  var cardVariant = get(params, 'variant');
  var generalCardsIconMap = {
    "Default": /*#__PURE__*/React.createElement(DefaultCards, {
      fields: fields,
      params: params
    }),
    "Drop": /*#__PURE__*/React.createElement(DropCards, {
      fields: fields,
      params: params
    })
  };
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var variables = BackgroundColorHex ? {
    '--general-card-complete-round-color': BackgroundColorHex
  } : {
    '--general-card-complete-round-color': selectedPrimaryColor
  };
  if (isNil(generalCardsIconMap[cardVariant])) {
    console.warn("component with \"".concat(cardVariant, "\" variant is not defined, try to use of this options ").concat(Object.values(EGeneralCardCompleteRoundTypes)));
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: variables,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, generalCardsIconMap[cardVariant]);
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    className = _ref2.className,
    anchorUrlParameter = _ref2.anchorUrlParameter,
    style = _ref2.style;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    style: style,
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, children);
};
var generalPaginationLinkContainer = "\n  display: flex;\n  align-items: center;\n\n  padding-top: 20px;\n\n  @media (max-width: 992px) {\n    padding-top: 0;\n    flex-direction: column-reverse;\n  }\n";
export var commonStyles = "c1cdj0mc";
export var ltrStyles = "lzc1gm9";
export var rtlStyles = "r1pie3qg";
export default GeneralCardCompleteRound;